/**
 * Number input widget.
 */

import type { FunctionComponent } from 'preact'

interface NumberInputProps {
  value: number | undefined
  onChange: (value: number | undefined) => void
  placeholder?: string
  disabled?: boolean
  min?: number
  max?: number
  step?: number
}

export const NumberInput: FunctionComponent<NumberInputProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  min,
  max,
  step,
}) => {
  return (
    <input
      type="number"
      class="syv-input"
      value={value ?? ''}
      placeholder={placeholder}
      disabled={disabled}
      min={min}
      max={max}
      step={step}
      onInput={(e) => {
        const input = e.target as HTMLInputElement
        const val = input.value
        onChange(val === '' ? undefined : Number(val))
      }}
      onBlur={(e) => {
        // Clamp to [min, max] on blur, as the app's own form does, so an
        // out-of-range number never reaches the run door's validation. Typing
        // stays free (an empty field stays empty for required-validation).
        const raw = (e.target as HTMLInputElement).value
        if (raw === '') return
        const n = Number(raw)
        if (Number.isNaN(n)) return
        let clamped = n
        if (min != null && clamped < min) clamped = min
        if (max != null && clamped > max) clamped = max
        if (clamped !== n) onChange(clamped)
      }}
    />
  )
}
